// extracted by mini-css-extract-plugin
export default {"zoomModal":"_ga-z"};